import parse from "html-react-parser";
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import notap_logo from '../../../assets/images/notap_logo.png';
import { getExtension, getFilename } from '../../../helpers/helpers';
import { image_extensions } from "../../../constants/english";
import { convertDateTime } from "../../../utils/lib";

export const PrintInbox = React.forwardRef((props, ref) => {
  const [fileExt, setFileExt] = useState('')
    const {
        // bankUserLoading,
        // bankUserErrorMsg,
        // bankUserSuccessMsg,
        digitalLetterManagement:{inboxLetterDetails, showDeleteConfirmationForm, showAttachmentModal}
    } = useSelector((state) => state.app)
    const {
        token,
        email
    } = useSelector((state) => state.authData)
    useEffect(()=>{
      setFileExt(getExtension(inboxLetterDetails?.ATTACH_DOCUMENTS))
    }, [])

  return (
    // <div ref={ref}>
    //   <p>ijuin</p>
    // </div>
      <div ref={ref} className="email-right-column p-4 p-xl-5">
        <div className="d-flex justify-content-between align-items-center mb-3">
            <div className="d-flex align-items-center">
                <img src={notap_logo} alt='Notap Logo'/>
                <h2 className="ml-3 text-dark font-weight-bold">NOTAP</h2>
            </div>
            <p className="text-dark font-weight-bold">{email}</p>
        </div>
          {/* <!-- Email Right Header --> */}
          <div className="email-right-header mb-2">
            {/* <!-- head left option --> */}
            {/* <div className="head-left-options">
              <button type="button" onClick={()=>{
                  navigate(`${appUrls.digital_letters}?tab=inbox`)
                  dispatch(setActiveEmailTab({name: 'inbox'}))
              }} className="btn btn-icon btn-outline btn-rounded-circle">
                <i className="mdi mdi-arrow-left"></i>
              </button>
              
            </div> */}
            {/* <!-- head right option --> */}
            {/* <div className="head-right-options">
              <div className="btn-group" role="group" aria-label="Basic example">
                <button type="button" className="btn border btn-pill">
                  <i className="mdi mdi-chevron-left"></i>
                </button>
                <button type="button" className="btn border btn-pill">
                  <i className="mdi mdi-chevron-right"></i>
                </button>
              </div>
            </div> */}
          </div>
          <div className="email-details">

            <div className="email-details-header">
              <h4 className="text-dark">
                 {inboxLetterDetails?.LETTER_SUBJECT ? inboxLetterDetails?.LETTER_SUBJECT : '(no subject)'}
              </h4>
            </div>

            <div className="email-details-content">
              <div className="email-details-content-header">

                <div className="media media-sm mb-lg-0">
                  <div className="media-sm-wrapper">
                    <div className='email-avatar'>
                    <p className='text-capitalize'>{inboxLetterDetails?.SENDER_EMAIL?.[0]}</p>
                  </div>
                  </div>
                  
                    {/* <div className='email-avatar'>
                    <p>{inboxLetterDetails?.SENDER_NAME?.[0]}</p>
                  </div> */}
                  <div className="media-body">
                    <h6 className="mt-0 text-dark font-weight-bold">{inboxLetterDetails?.SENDER_NAME}</h6>
                    <span>
                      From:
                      <i className="mdi mdi-chevron-left"></i>{inboxLetterDetails?.SENDER_EMAIL}
                      <i className="mdi mdi-chevron-right"></i>
                    </span>
                  </div>
                  {/* <div className="dropdown">
                <button className="btn dropdown-toggle border rounded-pill" type="button" id="dropdownMenuButton"
                  data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">More
                </button>
                <div className="dropdown-menu" aria-labelledby="dropdownMenuButton" x-placement="bottom-start"
                  style={{position: 'absolute', transform: 'translate3d(0px, 40px, 0px)', top: '0px', left: '0px', willChange: 'transform'}}>
                  <a className="dropdown-item" href="#">Action</a>
                  <a className="dropdown-item" href="#">Another action</a>
                  <a className="dropdown-item" href="#">Something else here</a>
                </div>
              </div> */}
                </div>

                <div className="email-details-content-header-right">
                  <span className="p-1 p-xl-2">{convertDateTime(inboxLetterDetails.CREATED_AT, "MMM DD, YYYY, HH:mm A")}</span>

                  {/* <a className="text-color p-1 p-xl-2" href="#">
                    <i className="mdi mdi-star-outline"></i>
                  </a> */}

                  {/* <div className="dropdown">

                    <a className="btn dropdown-toggle icon-burger-mini" href="#" role="button" id="dropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    </a>

                    <div className="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuLink">
                      <a className="dropdown-item" href="#">Action</a>
                      <a className="dropdown-item" href="#">Another action</a>
                      <a className="dropdown-item" href="#">Something else here</a>
                    </div>
                  </div> */}


                </div>
              </div>
              <div>
              {inboxLetterDetails?.LETTER_CONTENTS &&
                <div>{parse(inboxLetterDetails.LETTER_CONTENTS)}</div>
              }  
              {inboxLetterDetails?.DIGITAL_SIGNATURE &&
                <div className='mt-4'>
                  <img className='digital-signature-img' src={inboxLetterDetails?.DIGITAL_SIGNATURE} alt='letter signature'/>
                </div>
              }
              {/* <p className="pt-4">
                <i className="fa fa-paperclip ml-2"></i>
                <span className="text-dark">Attachment</span>
              </p> */}
              {/* <div className='col-12 col-md-6 col-lg-5'></div> */}
              {inboxLetterDetails?.ATTACH_DOCUMENTS &&
              
              <div className='pt-7 col-12 col-md-6 col-lg-5'>
                <h6 className='mb-2'><i className="mdi mdi-paperclip ml-2"></i> Attachment</h6>
                <div className='border d-flex justify-content-between p-2'>
                {/* <p className='file-name-display'>{fileExt == 'png' ? `Image.${fileExt}`
                : `Document.${fileExt}`}</p> */}
                <div style={{columnGap: '0.5rem', maxWidth: '93%'}} className='d-flex align-items-center'>
                  {image_extensions.includes((getExtension(inboxLetterDetails?.ATTACH_DOCUMENTS)).toLowerCase()) ?
                    <i style={{fontSize: '2rem'}} className="mdi mdi-image"></i> :
                    <i style={{fontSize: '2rem'}} className="mdi mdi-file-pdf-box"></i>
                  }
                  <span className="file-name-display">{getFilename(inboxLetterDetails?.ATTACH_DOCUMENTS)}</span>
                </div>
                {/* <button className='font-weight-bold' onClick={()=>{
                  setDocAttachmentName("")
                }}>X</button> */}
              </div>
              </div>
              }
              </div>
            </div>
          </div>
        </div>   
  )
})


